import React from 'react'
import { InputV2, InputPropsV2 } from '@evrekadev/evreka-ui-components'

const InputText = React.forwardRef<HTMLInputElement, InputPropsV2>(
  ({ onChange, value, ...props }, ref) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = e.target.value
      // Only update if the new value is not empty or contains non-whitespace characters
      if (newValue === '' || newValue.trim() !== '') {
        onChange?.(e)
      } else {
        // If it's whitespace-only, don't update the value
        e.preventDefault()
      }
    }

    return <InputV2 type="text" ref={ref} onChange={handleChange} value={value} {...props} />
  },
)

export default InputText
